import { render, staticRenderFns } from "./HelpAbout.vue?vue&type=template&id=187c2f54&"
import script from "./HelpAbout.vue?vue&type=script&lang=js&"
export * from "./HelpAbout.vue?vue&type=script&lang=js&"
import style0 from "./HelpAbout.vue?vue&type=style&index=0&id=187c2f54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports